module.exports = __webpack_public_path__ + "img/germany-ischemic-heart-disease-female.28106231.png";